import { useTranslation } from 'react-i18next'
import { Icon } from '@/components/ui/icon'
import { SHOPIFY_APP_STORE_URL } from '@/config/public-links'

interface HeroProps {
  readonly answersHref: string
}

const CHOOSER_KEYS = ['selling', 'operating', 'automating'] as const

export function Hero({ answersHref }: HeroProps) {
  const { t, i18n } = useTranslation()

  return (
    <section className="lp-hero-wrap">
      <div className="lp-hero">
        <img
          className="lp-hero-image"
          src="/assets/landing/merchant-studio.webp"
          alt={t('landing:hero.image_alt')}
          width={1536}
          height={1024}
          fetchPriority="high"
        />
        <div className="lp-hero-copy lp-enter">
          <p className="lp-eyebrow">{t('landing:hero.eyebrow')}</p>
          <h1><span className="lp-heading-phrase">{t('landing:hero.title')}</span>{i18n.resolvedLanguage === 'zh-TW' ? '' : ' '}<span className="lp-heading-phrase lp-hero-accent">{t('landing:hero.title_accent')}</span></h1>
          <p className="lp-hero-description">{t('landing:hero.subtitle')}</p>
          <div className="lp-hero-actions">
            <a className="lp-button" href={SHOPIFY_APP_STORE_URL}>
              {t('landing:nav.install')}<Icon name="nav.arrowRight" size="sm" aria-hidden />
            </a>
            <a className="lp-text-link" href={answersHref}>{t('landing:hero.cta_secondary')}</a>
          </div>
          <p className="lp-hero-note">{t('landing:hero.note')}</p>
        </div>
      </div>
    </section>
  )
}

export function AnswerChooser({ answersHref }: HeroProps) {
  const { t } = useTranslation()

  return (
    <section className="lp-guide lp-section" aria-labelledby="guide-title">
      <div className="lp-container">
        <div className="lp-section-intro">
          <p className="lp-eyebrow">{t('landing:hero.chooser.eyebrow')}</p>
          <h2 id="guide-title">{t('landing:hero.chooser.title')}</h2>
          <p>{t('landing:hero.chooser.description')}</p>
        </div>
        <ul className="lp-question-list">
          {CHOOSER_KEYS.map((key, index) => (
            <li key={key}>
              <a className="lp-question" href={t(`landing:hero.chooser.items.${key}.href`)}>
                <span className="lp-question-number" aria-hidden>{String(index + 1).padStart(2, '0')}</span>
                <span>
                  <span className="lp-question-area">{t(`landing:hero.chooser.items.${key}.area`)}</span>
                  <span className="lp-question-title">{t(`landing:hero.chooser.items.${key}.question`)}</span>
                </span>
                <Icon name="nav.arrowRight" size="lg" aria-hidden />
              </a>
            </li>
          ))}
        </ul>
        <a href={answersHref} className="lp-text-link lp-guide-link">{t('landing:nav.guide')} <Icon name="nav.arrowRight" size="sm" aria-hidden /></a>
      </div>
    </section>
  )
}
